import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Loading from "../common-components/Sidebar/Loader";
import Dashboard from "../components/Dashboard/Dashboard";
import ASAP from "../components/DataIngestion/ASAP";
import PageNotFound from "../common-components/PageNotFound";
import UserManagement from "../components/UserManagement/UserManagement";
import UserTable from "../components/UserManagement/UserTable";
import BookBuBTable from "../components/DataIngestion/CommonTable/BookBubTable";
import BookBub from "../components/DataIngestion/BookBubMain";


const Layout = React.lazy(() => import("../router/layout"));

const DataIngestion=React.lazy(()=>import("../../src/components/DataIngestion/DataIngestionMain"))
const Tabs=React.lazy(()=>import('../components/DataIngestion/AllTabs'));
const KddData=React.lazy(()=>import("../components/DataIngestion/kdd/KddData"))
export const routes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    // loader:,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <Dashboard />
              </Suspense>
            }
          />
        ),
      },
  
      {
        path: "data_ingestion",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <DataIngestion />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "deal",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <Tabs/>
              </Suspense>
            }
          />
        ),
      },
      // {
      //   path: "/view",
      //   element: (
      //     <ProtectedRoute
      //       element={
      //         <Suspense
      //           fallback={
      //             <Loading
      //               isLoading={true}
      //               height={80}
      //               width={80}
      //               color="#15223F"
      //             ></Loading>
      //           }
      //         >
      //           <View />
      //         </Suspense>
      //       }
      //     />
      //   ),
      // },
      {
        path: "deal/:title",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <KddData />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "Kdd",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <KddData />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "asap",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <ASAP />
              </Suspense>
            }
          />
        ),
      },
        {
        path: "bookbub",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <BookBub />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "usermanagement",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <UserManagement />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "Usertable",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  ></Loading>
                }
              >
                <UserTable />
              </Suspense>
            }
          />
        ),
      },
      
    ],
  },
   {
    path: "*",
    element: (
      <Suspense
        fallback={
          <Loading
            isLoading={true}
            height={80}
            width={80}
            color="#15223F"
          ></Loading>
        }
      >
        <PageNotFound/>
      </Suspense>
    ),
    // loader:,
  },
 
]);